import { type SvgIconProps } from '@common/components/svgs/props';

function IconArrowDown(
  { size = 16, color = 'scheme-feedback-text-color', ...rest }: Readonly<SvgIconProps>,
) {
  return (
    <svg
      {...rest}
      xmlns="http://www.w3.org/2000/svg"
      height={size}
      width={size}
      viewBox="0 0 16 16"
      fill="none"
      data-testid="svg-ArrowDown"
    >
      <path
        clipRule="evenodd"
        d="m2.41421 4.79184-1.41421 1.41421 5.37939 5.37935-.00029.0003 1.41421 1.4143 6.79769-6.7977-1.4142-1.41421-5.38319 5.38311z"
        fill={`var(--${color})`}
        fillRule="evenodd"
      />
    </svg>
  );
}

IconArrowDown.displayName = 'ArrowDown';

export default IconArrowDown;
